import { Box, Stack, styled } from '@mui/material'

export const AccessTag = styled(Box)`
  background-color: #fff;
  border-radius: 0px !important;
  padding: 2px 3px;
  margin: 5px;
  font-size: 13px;
`

export const ScorollerBox = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  height: 'calc(100vh - 107px)',
}))

export const TableWrapper = styled(Box)`
  padding: 0 13px;
`
export const Container = styled(Stack)`
  gap: 10px;
  height: 100%;
  width: 100%;
  background-color: #fff;
`
